import React from "react";
import { Card, Accordion } from "react-bootstrap";

export default function Step6Grommet3({
  ContextAwareToggle,
  t,
  requiredStep,
  stepSelectedLabel,
  step6,
  widthCart,
  step5,
  step3A0,
  setStep6,
  selectChanged,
  setExtendedTitle,
  extendedTitle,
  setDeps,
  setCart,
  inputs,
  pageLanguage,
  NextStep,
  modalHandleShow,
  setPanelSheerWarningTemp,
  setStep6BHead,
  step8B,
  step6BHead,
  tracksList,
  step2A,
  setStep6B,
  step6B,
  step6CHead,
  setStep6CHead,
  step6C,
  setStep6C,
  step8C,
  PopoverStickOnHover,
  popoverThumbnailHover,
  popoverImages,
  step2B,
  tracksList2,
  step2C,
  setPanelPLWarningTemp,
  loadingPrice,
  windowWidthPanelType,
}) {
  return (
    <Card>
      <Card.Header>
        <ContextAwareToggle
          eventKey="6"
          stepNum={t("5")}
          stepTitle={t("grommet_step6")}
          stepRef="6"
          type="1"
          required={requiredStep["6"]}
          stepSelected={stepSelectedLabel["6"] === undefined ? "" : stepSelectedLabel["6"]}
        />
      </Card.Header>
      <Accordion.Collapse eventKey="6">
        <Card.Body>
          <div
            className={
              widthCart === undefined || step5 === "" || step3A0 === ""
                ? "card_body card_body_info"
                : "noDisplay"
            }
          >
            <div>
              {loadingPrice ? (
                <div className="boxPleaseWait"></div>
              ) : (
                <div>
                  <div className="card_body_info_header">
                    <h1 className="card_body_info_header_title">{t("more_info")}</h1>
                  </div>

                  <hr />
                  <div className="card_body_info_body">
                    <p className="card_body_info_text">
                      {step2B === ""
                        ? t("panel_type3_text1_new")
                        : widthCart === undefined && step3A0 === ""
                        ? t("panel_type3_text2_new")
                        : widthCart === undefined && step3A0 === ""
                        ? t("panel_type3_text2")
                        : widthCart === undefined && step3A0 !== ""
                        ? t("panel_type3_text3_grommet1_new")
                        : t("panel_type3_text4_new_grommet3")}
                    </p>
                  </div>
                  <NextStep currentStep="6" eventKey="7">
                    {t("NEXT STEP")}
                  </NextStep>
                </div>
              )}
            </div>
          </div>

          <div
            className={
              widthCart !== undefined && step5 !== ""
                ? "card_body_panel_type special_farsi_card_body"
                : "noDisplay"
            }
          >
            <div className="card_body card_body_radio Customize_Style_container">
            {parseInt(windowWidthPanelType) > 160  && (
                      <div className="secondary_options_step5">
                        <span className="checkbox_text checkBoxPanelType">{t("title_step8_panel_type")}</span>
                      </div>
                    )}
              <div className="box100" style={{padding: "0 0.4rem"}}>
                <p className="step_selection_title">{t("Sheer Curtain Panel Type")}</p>
                <div
                  className={
                    step2B !== "None" && step5 !== "" && parseInt(windowWidthPanelType) > 160
                      ? "grommet_curtain_button_container grommet_curtain_button_container_separated"
                      : "noDisplay"
                  }
                >
                  <div className="dk_curtain_symmetric_buttons dk_curtain_symmetric_buttons_separated">
                    <button
                      className={`dk_curtain_symmetric_button_left btn ${
                        step6BHead === "Rod" ? "dk_curtain_symmetric_button_on" : ""
                      }`}
                      onClick={() => {
                        if (parseInt(windowWidthPanelType) > 160 && step8B === "Track") {
                          modalHandleShow("panelSheerWarning");
                          setPanelSheerWarningTemp({
                            stepValue: "Rod",
                            id: "",
                            cartValue: "",
                            event: undefined,
                          });
                        } else {
                          setStep6BHead("Rod");
                          setStep6B("");
                          setDeps("6", "");
                          setCart("", "", "PanelTypeB");
                        }
                      }}
                    >
                       <img
                        src={require("../../Images/icon/Rodicon.svg").default }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <span>{t("Rod")}</span>
                    </button>
                    <button
                      className={`dk_curtain_symmetric_button_right btn ${
                        step6BHead === "Track" ? "dk_curtain_symmetric_button_on" : ""
                      } ${tracksList.length > 0 && step2A !== "Grommet" ? "" : "crossed"}`}
                      onClick={() => {
                        if (parseInt(windowWidthPanelType) > 160 && step8B === "Rod") {
                          modalHandleShow("panelSheerWarning");
                          setPanelSheerWarningTemp({
                            stepValue: "Track",
                            id: "",
                            cartValue: "",
                            event: undefined,
                          });
                        } else {
                          setStep6BHead("Track");
                          setStep6B("");
                          setDeps("6", "");
                          setCart("", "", "PanelTypeB");
                        }
                      }}
                    >
                       <img
                    src={require("../../Images/icon/trackicon.svg").default }
                    className="img-fluid height_auto"
                    alt=""
                  />
                      <span>{t("Track")}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="box100"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "fa" ? "row-reverse" : "row",
                }}
              >
              <div
                className={
                  step6BHead === "Rod"
                    ? parseInt(windowWidthPanelType) <= 160 || step5 === "Decorative"
                      ? "box33 radio_style"
                      : "noDisplay"
                    : "box33 radio_style"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_left.svg").default
                      : require("../../Images/drapery/grommet/panel_type_left.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Single Panel")}
                  value="1"
                  name="step6B"
                  ref-num="6"
                  id="6B1"
                  checked={step6B === "Single Panel"}
                  onChange={(e) => {
                    setStep6B("Single Panel");
                    let tempExtended = extendedTitle;
                    tempExtended["6"][0] = [
                      parseInt(windowWidthPanelType) < 160
                        ? t("Sheer Panel Single Panel")
                        : t("Sheer Panel Rod Single Panel"),
                    ];
                    setExtendedTitle(tempExtended);
                    setCart("PanelTypeB", "Single Panel");
                    if (step2B === "None") {
                      setDeps("", "6,61,6B,6C");
                      selectChanged(e);
                    } else {
                      setDeps("", "6B");
                    }
                  }}
                  ref={(ref) => (inputs.current["6B1"] = ref)}
                />
                <label htmlFor="6B1">{t("Single Panel")}</label>
              </div>
           
              <div
                className={
                  step6BHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 160
                        ? parseInt(windowWidthPanelType) > 320
                          ? "noDisplay"
                          : "box33 radio_style radio_recommended wide_panel_type"
                        : "box33 radio_style"
                      : "box33 radio_style"
                    : "box33 radio_style"
                }
              >
                <img
                  src={
                    step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 160 && step6BHead === "Rod"
                        ? pageLanguage === "fa"
                          ? require("../../Images/drapery/grommet/panel_type_both2.svg").default
                          : require("../../Images/drapery/grommet/panel_type_both2.svg").default
                        : pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : require("../../Images/drapery/grommet/panel_type_both.svg").default
                      : pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                      : require("../../Images/drapery/grommet/panel_type_both.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Pair, Split Draw")}
                  value="5"
                  name="step6B"
                  ref-num="6"
                  id="6B5"
                  checked={step6B === "Pair, Split Draw"}
                  onChange={(e) => {
                    setStep6B("Pair, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"][0] = [
                      parseInt(windowWidthPanelType) < 160
                        ? t("Sheer Panel Pair, Split Draw")
                        : t("Sheer Panel Rod Pair, Split Draw"),
                    ];
                    setExtendedTitle(tempExtended);
                    setCart("PanelTypeB", "Pair, Split Draw");
                    if (step2B === "None") {
                      setDeps("", "6,61,6B,6C");
                      selectChanged(e);
                    } else {
                      setDeps("", "6B");
                    }
                    if (step5 === "Full" && parseInt(windowWidthPanelType) > 320 && step6BHead === "Rod") {
                      modalHandleShow("panelTypeWarning");
                    }
                  }}
                  ref={(ref) => (inputs.current["6B5"] = ref)}
                />
                <label htmlFor="6B5">{t("Pair, Split Draw")}</label>
                {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
              </div>
              </div>


              <div
                      className={
                        step5 === "Full" && parseInt(windowWidthPanelType) > 320
                          ? "box100"


                          : "noDisplay"
                      }
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        flexDirection: pageLanguage === "en" ? "row-reverse" : "row",
                      }}
                    >

              <div
                className={
                  step6BHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                    : "noDisplay"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_four.svg").default
                      : require("../../Images/drapery/grommet/panel_type_four.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Four Panel, Split Draw")}
                  value="6"
                  name="step6B"
                  ref-num="6"
                  id="6B7"
                  checked={step6B === "Four Panel, Split Draw"}
                  onChange={(e) => {
                    setStep6B("Four Panel, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"][0] = [t("Sheer Panel Four Panel, Split Draw")];
                    setExtendedTitle(tempExtended);
                    if (step2B === "None") {
                      setDeps("", "6,61,6B,6C");
                      selectChanged(e);
                    } else {
                      setDeps("", "6B");
                    }
                    setCart("PanelTypeB", "Four Panel, Split Draw");
                  }}
                  ref={(ref) => (inputs.current["6B7"] = ref)}
                />
                <label htmlFor="6B7">{t("Four Panel, Split Draw")}</label>
                  {/* <div className="radio_recommended_text">
                    {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                  </div> */}
              </div>
              <div
                className={
                  step6BHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                    : "noDisplay"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_three.svg").default
                      : require("../../Images/drapery/grommet/panel_type_three.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Three Panel, Split Draw")}
                  value="6"
                  name="step6B"
                  ref-num="6"
                  id="6B6"
                  checked={step6B === "Three Panel, Split Draw"}
                  onChange={(e) => {
                    setStep6B("Three Panel, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"][0] = [t("Sheer Panel Three Panel, Split Draw")];
                    setExtendedTitle(tempExtended);
                    if (step2B === "None") {
                      setDeps("", "6,61,6B,6C");
                      selectChanged(e);
                    } else {
                      setDeps("", "6B");
                    }
                    setCart("PanelTypeB", "Three Panel, Split Draw");
                  }}
                  ref={(ref) => (inputs.current["6B6"] = ref)}
                />
                <label htmlFor="6B6">{t("Three Panel, Split Draw")}</label>
                {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
              </div>
                    </div>
              {step2B === "None" && (
                <NextStep currentStep="6" eventKey="7">
                  {t("NEXT STEP")}
                </NextStep>
              )}
            </div>
            <div
              className={
                step2B !== "None" && step2C !== ""
                  ? "card_body card_body_radio Customize_Style_container"
                  : "noDisplay"
              }
            >
              <div className="box100" style={{padding: "0 0.4rem"}}>
                <p className="step_selection_title 1">{t("Privacy Layer Panel Type")}</p>
                <div
                  className={
                    step2B !== "None" && step5 !== "" && parseInt(windowWidthPanelType) > 160
                      ? "grommet_curtain_button_container grommet_curtain_button_container_separated"
                      : "noDisplay"
                  }
                >
                  <div className="dk_curtain_symmetric_buttons dk_curtain_symmetric_buttons_separated">
                    <button
                      className={`dk_curtain_symmetric_button_left btn ${
                        step6CHead === "Rod" ? "dk_curtain_symmetric_button_on" : ""
                      }`}
                      onClick={() => {
                        if (parseInt(windowWidthPanelType) > 160 && step8C === "Track") {
                          modalHandleShow("panelPLWarning");
                          setPanelPLWarningTemp({
                            stepValue: "Rod",
                            id: "",
                            cartValue: "",
                            event: undefined,
                          });
                        } else {
                          setStep6CHead("Rod");
                          setStep6C("");
                          setDeps("6C", "");
                          setCart("", "", "PanelTypeC");
                        }
                      }}
                    >
                      <img
                        src={require("../../Images/icon/Rodicon.svg").default }
                        className="img-fluid height_auto"
                        alt=""
                      />
                      <span>{t("Rod")}</span>
                    </button>
                    <button
                      className={`dk_curtain_symmetric_button_right btn ${
                        step6CHead === "Track" ? "dk_curtain_symmetric_button_on" : ""
                      } ${tracksList2.length > 0 ? "" : "crossed"}`}
                      onClick={() => {
                        if (parseInt(windowWidthPanelType) > 160 && step8C === "Rod") {
                          modalHandleShow("panelPLWarning");
                          setPanelPLWarningTemp({
                            stepValue: "Track",
                            id: "",
                            cartValue: "",
                            event: undefined,
                          });
                        } else {
                          setStep6CHead("Track");
                          setStep6C("");
                          setDeps("6C", "");
                          setCart("", "", "PanelTypeC");
                        }
                      }}
                    >
                      <img
                    src={require("../../Images/icon/trackicon.svg").default }
                    className="img-fluid height_auto"
                    alt=""
                  />
                      <span>{t("Track")}</span>
                    </button>
                  </div>
                </div>
              </div>
              <div
                className="box100"
                style={{
                  display: "flex",
                  justifyContent: "space-around",
                  flexDirection: pageLanguage === "fa" ? "row-reverse" : "row",
                }}
              >
              <div
                className={
                  parseInt(windowWidthPanelType) > 160
                    ? step6CHead === "Track"
                      ? step6CHead === "Rod"
                        ? parseInt(windowWidthPanelType) <= 160 || step5 === "Decorative"
                          ? "box33 radio_style"
                          : "noDisplay"
                        : "box33 radio_style"
                      : "noDisplay"
                    : "box33 radio_style"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_left.svg").default
                      : require("../../Images/drapery/grommet/panel_type_left.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Single Panel")}
                  value="1"
                  name="step6C"
                  ref-num="6"
                  id="6C1"
                  checked={step6C === "Single Panel"}
                  onChange={(e) => {
                    setStep6C("Single Panel");
                    let tempExtended = extendedTitle;
                    tempExtended["6"][1] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Privacy Layer")}
                        </span>
                        <span className="step_title_extended_list_item_text">
                          {parseInt(windowWidthPanelType) < 160 ? t("Single Panel") : t("Track Single Panel")}
                        </span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                    setDeps("", "6,6C");
                    setCart("PanelTypeC", "Single Panel");
                  }}
                  ref={(ref) => (inputs.current["6C1"] = ref)}
                />
                <label htmlFor="6C1">{t("Single Panel")}</label>
              </div>
             
              <div
                className={
                  step6CHead === "Rod"
                    ? step5 !== ""
                      ? parseInt(windowWidthPanelType) > 160
                        ? parseInt(windowWidthPanelType) > 320
                          ? "noDisplay"
                          : "box33 radio_style radio_recommended wide_panel_type"
                        : "box33 radio_style"
                      : "box33 radio_style"
                    : "box33 radio_style"
                }
              >
                <img
                  src={
                    step5 !== ""
                      ? parseInt(windowWidthPanelType) > 160 && step6CHead === "Rod"
                        ? pageLanguage === "fa"
                          ? require("../../Images/drapery/grommet/panel_type_both2.svg").default
                          : require("../../Images/drapery/grommet/panel_type_both2.svg").default
                        : pageLanguage === "fa"
                        ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                        : require("../../Images/drapery/grommet/panel_type_both.svg").default
                      : pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_both.svg").default
                      : require("../../Images/drapery/grommet/panel_type_both.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Pair, Split Draw")}
                  value="5"
                  name="step6C"
                  ref-num="6"
                  id="6C5"
                  checked={step6C === "Pair, Split Draw"}
                  onChange={(e) => {
                    setStep6C("Pair, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"][1] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Privacy Layer")}
                        </span>
                        <span className="step_title_extended_list_item_text">
                          {parseInt(windowWidthPanelType) < 160
                            ? t("Pair, Split Draw")
                            : step6CHead === "Rod"
                            ? t("Rod Pair, Split Draw")
                            : t("Track Pair, Split Draw")}
                        </span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                    setDeps("", "6,6C");
                    setCart("PanelTypeC", "Pair, Split Draw");
                    selectChanged(e);
                    if (step5 === "Full" && parseInt(windowWidthPanelType) > 320 && step6CHead === "Rod") {
                      modalHandleShow("panelTypeWarning");
                    }
                  }}
                  ref={(ref) => (inputs.current["6C5"] = ref)}
                />
                <label htmlFor="6C5">{t("Pair, Split Draw")}</label>
                {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
              </div>
              </div>
              <div
                      className={
                        step5 === "Full" && parseInt(windowWidthPanelType) > 320
                          ? "box100"
                          : "noDisplay"
                      }
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        flexDirection: pageLanguage === "en" ? "row-reverse" : "row",
                      }}
                    >

              <div
                className={
                  step6CHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                    : "noDisplay"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_four.svg").default
                      : require("../../Images/drapery/grommet/panel_type_four.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Four Panel, Split Draw")}
                  value="6"
                  name="step6C"
                  ref-num="6"
                  id="6C7"
                  checked={step6C === "Four Panel, Split Draw"}
                  onChange={(e) => {
                    setStep6C("Four Panel, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"][1] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Privacy Layer")}
                        </span>
                        <span className="step_title_extended_list_item_text">
                          {t("Four Panel, Split Draw")}
                        </span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                    setDeps("", "6,6C");
                    setCart("PanelTypeC", "Four Panel, Split Draw");
                    selectChanged(e);
                  }}
                  ref={(ref) => (inputs.current["6C7"] = ref)}
                />
                <label htmlFor="6C7">{t("Four Panel, Split Draw")}</label>
                {/* <div className="radio_recommended_text">
                    {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                  </div> */}
                </div>
              <div
                className={
                  step6CHead === "Rod"
                    ? step5 === "Full"
                      ? parseInt(windowWidthPanelType) > 320
                        ? "box50 radio_style"
                        : "noDisplay"
                      : "noDisplay"
                    : "noDisplay"
                }
              >
                <img
                  src={
                    pageLanguage === "fa"
                      ? require("../../Images/drapery/grommet/panel_type_three.svg").default
                      : require("../../Images/drapery/grommet/panel_type_three.svg").default
                  }
                  className="img-fluid height_auto"
                  alt=""
                />
                <input
                  className="radio"
                  type="radio"
                  text={t("Three Panel, Split Draw")}
                  value="6"
                  name="step6C"
                  ref-num="6"
                  id="6C6"
                  checked={step6C === "Three Panel, Split Draw"}
                  onChange={(e) => {
                    setStep6C("Three Panel, Split Draw");
                    let tempExtended = extendedTitle;
                    tempExtended["6"][1] = (
                      <li key="3" className="step_title_extended_list_item">
                        <span className="step_title_extended_list_item_title">
                          {t("Privacy Layer")}
                        </span>
                        <span className="step_title_extended_list_item_text">
                          {t("Three Panel, Split Draw")}
                        </span>
                      </li>
                    );
                    setExtendedTitle(tempExtended);
                    setDeps("", "6,6C");
                    setCart("PanelTypeC", "Three Panel, Split Draw");
                    selectChanged(e);
                  }}
                  ref={(ref) => (inputs.current["6C6"] = ref)}
                />
                <label htmlFor="6C6">{t("Three Panel, Split Draw")}</label>
                {/* <div className="radio_recommended_text">
                  {t("RECOMMENDED FOR YOUR MEASUREMENTS")}
                </div> */}
              </div>
                    </div>
              <NextStep currentStep="6" eventKey="7">
                {t("NEXT STEP")}
              </NextStep>
            </div>
            <div
              className={
                step2B !== "None" && step2C === ""
                  ? "card_body card_body_radio Customize_Style_container"
                  : "noDisplay"
              }
            >
              <div className="box100">
                <p className="step_selection_title 2">{t("Privacy Layer Panel Type")}</p>
              </div>
              <div className="checkbox_text_info_container">
                <div className="card-body-display-flex">
                  <span className="checkbox_text">{t("pl_hs_incomplete")}</span>
                </div>
              </div>
              <NextStep currentStep="6" eventKey="7">
                {t("NEXT STEP")}
              </NextStep>
            </div>
          </div>
          {widthCart !== undefined && step5 !== "" && (
            <div className="accordion_help">
              <div className={`help_container ${pageLanguage === "fa" ? "help_container_fa" : ""}`}>
                <div className="help_column help_left_column">
                  <p className="help_column_header">{t("grommet_panel_type_help_1")}</p>
                  <ul className="help_column_list">
                    <li className="no_listStyle">
                      <span className="popover_indicator">
                        {
                          <PopoverStickOnHover
                            placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                            children={
                              <object
                                className="popover_camera"
                                type="image/svg+xml"
                                data={require("../../Images/public/camera.svg").default}
                              />
                            }
                            component={
                              <div className="clearfix">
                                <div className="popover_image clearfix">
                                  <img
                                    src={
                                      popoverImages["step61"] === undefined
                                        ? require("../../Images/drapery/grommet/single_panel.jpg")
                                        : popoverImages["step61"]
                                    }
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="popover_footer">
                                  <span className="popover_footer_title">
                                    {t("grommet_panel_type_help_1")}
                                  </span>
                                  <span className="popover_thumbnails">
                                    <div>
                                      <img
                                        src={require("../../Images/drapery/grommet/single_panel.jpg")}
                                        text="step61"
                                        onMouseEnter={(e) => popoverThumbnailHover(e)}
                                        className="popover_thumbnail_img img-fluid"
                                        alt=""
                                      />
                                    </div>
                                  </span>
                                </div>
                              </div>
                            }
                          />
                        }
                      </span>
                      {t("grommet_panel_type_help_2")}
                    </li>
                    <li>{t("grommet_panel_type_help_3")}</li>
                  </ul>
                </div>
                <div className="help_column help_right_column">
                  <p className="help_column_header">{t("grommet_panel_type_help_4")}</p>
                  <ul className="help_column_list">
                    <li className="no_listStyle">
                      <span className="popover_indicator">
                        {
                          <PopoverStickOnHover
                            placement={`${pageLanguage === "fa" ? "right" : "left"}`}
                            children={
                              <object
                                className="popover_camera"
                                type="image/svg+xml"
                                data={require("../../Images/public/camera.svg").default}
                              />
                            }
                            component={
                              <div className="clearfix">
                                <div className="popover_image clearfix">
                                  <img
                                    src={
                                      popoverImages["step52"] === undefined
                                        ? require("../../Images/drapery/grommet/pair_panel.jpg")
                                        : popoverImages["step52"]
                                    }
                                    className="img-fluid"
                                    alt=""
                                  />
                                </div>
                                <div className="popover_footer">
                                  <span className="popover_footer_title">
                                    {t("grommet_panel_type_help_6")}
                                  </span>
                                  <span className="popover_thumbnails">
                                    <div>
                                      <img
                                        src={require("../../Images/drapery/grommet/pair_panel.jpg")}
                                        text="step52"
                                        onMouseEnter={(e) => popoverThumbnailHover(e)}
                                        className="popover_thumbnail_img img-fluid"
                                        alt=""
                                      />
                                    </div>
                                  </span>
                                </div>
                              </div>
                            }
                          />
                        }
                      </span>
                      {t("grommet_panel_type_help_6")}
                    </li>
                    <li>{t("grommet_panel_type_help_7")}</li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Card.Body>
      </Accordion.Collapse>
    </Card>
  );
}
